import {
  microsoftAuthApiRef,
  OAuthApi,
  useApi,
} from '@backstage/core-plugin-api';
import {
  CustomFieldExtensionSchema,
  FieldExtensionComponentProps,
  useTemplateSecrets,
} from '@backstage/plugin-scaffolder-react';
import {
  getAudForEnv,
  getDefaultUserScopes,
  getUserAccessToken,
} from '@internal/workload-api-helper';
import { Typography } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import useDebounce from 'react-use/lib/useDebounce';

export const RequesterFieldExtensionSchema: CustomFieldExtensionSchema = {
  uiOptions: {
    type: 'object',
    required: ['fieldName'],
    properties: {
      fieldName: {
        description:
          'The name of the field use to validate in the accounts API',
        type: 'string',
      },
      allowedEmpty: {
        description:
          "A flag indicating if a blank value is allowed. Used to bypass backstage's redundant validation on blank fields. Defaults to false.",
        type: 'boolean',
        default: true,
      },
      formattedHelp: {
        description:
          'Field (likly hidden) to retrieve user token for aws workload',
        type: 'string',
      },
      cacheUserToken: {
        description:
          "Flag indicating whether to cache the user's access token for the accounts API.",
        type: 'boolean',
        default: true,
      },
    },
  },
  returnValue: { type: 'string' },
};

let identity: OAuthApi;

export const RequesterField = ({
  onChange,
  rawErrors,
  required,
  formData,
  schema,
  uiSchema,
}: FieldExtensionComponentProps<string>) => {
  // Set up variables for accounts-api validation call
  identity = useApi(microsoftAuthApiRef);
  const { setSecrets } = useTemplateSecrets();

  useDebounce(
    async () => {
      const cacheUserToken = uiSchema?.['ui:options']
        ?.cacheUserToken as boolean;
      if (!cacheUserToken) {
        return;
      }
      try {
        const user_token = await getUserAccessToken(
          identity,
          getAudForEnv(),
          getDefaultUserScopes(),
        );
        setSecrets({ AWS_API_USER_TOKEN: user_token });
      } catch (error) {
        // console.log(error);
      }
    },
    500,
    [formData],
  );
  const fieldName = uiSchema?.['ui:options']?.fieldName as string;
  return (
    <FormControl
      margin="normal"
      required={required}
      error={rawErrors !== undefined && rawErrors.length > 0 && !formData}
    >
      <InputLabel htmlFor={`${fieldName}Input`}>{schema.title}</InputLabel>
      <Input
        id={`${fieldName}Input`}
        defaultValue={formData}
        aria-describedby={`${fieldName}HelperText`}
        onChange={e => onChange(e.target?.value)}
      />
      {uiSchema?.['ui:options'] !== undefined && (
        <FormHelperText id={`${fieldName}HelperText`}>
          <Typography variant="body1">
            <div
              dangerouslySetInnerHTML={{
                __html: uiSchema['ui:options'].formattedHelp as string,
              }}
            />
          </Typography>
        </FormHelperText>
      )}
    </FormControl>
  );
};
